import { jsx } from 'react/jsx-runtime';
import { IconCore } from '../Icon.Core/Icon.Core.es.js';
import { SvgIconsGradient } from './Icon.Gradient.Icons.es.js';
import { gradients } from './gradients/index.es.js';

const IconGradient = ({ variant, name, size = 16, className, ...props })=>{
    const iconName = name.toLowerCase();
    const Gradient = gradients[variant];
    const type = SvgIconsGradient[name];
    return jsx(Gradient, {
        className: className,
        "data-testid": `icon-gradient-${iconName}`,
        size: size,
        type: type,
        children: jsx(IconCore, {
            ...props,
            name: name,
            size: size
        })
    });
};
IconGradient.displayName = 'Icon.Gradient';

export { IconGradient, IconGradient as default };
//# sourceMappingURL=Icon.Gradient.es.js.map
